const HomeWhyUserLoveSimpleWasteSection = () => (
    <div className="max-w-[1536px] m-auto ">
        <div className="flex flex-col space-y-6 py-10 px-6 sm:px-10 md:px-20 xl:px-24 ">
            <h1 className="h3 sm:h2 text-base-dark lg:h1">Accelerate<br/> With SimpleWaste. </h1>
            <div className="h-2 w-40 bg-gradient-to-l from-[#86EFAC] to-[#67E8F9]"></div>
        </div>        
    </div>
)

export default HomeWhyUserLoveSimpleWasteSection